export default "__VITE_ASSET__9e78c0fd__"